import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogRef
} from '@angular/material/dialog';
import { UiModule } from '@app/ui';
import { MaterialModule } from '@app/ui/material.module';

interface DialogData {
  deletableTransactionsCount: number;
}

@Component({
  standalone: true,
  selector: 'sbnb-dialog-delete-recurring-transaction',
  templateUrl: './dialog-delete-recurring-transaction.component.html',
  imports: [CommonModule, UiModule, MaterialModule, ReactiveFormsModule],
})
export class DialogDeleteRecurringTransactionComponent {
  form: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<DialogDeleteRecurringTransactionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private fb: FormBuilder
  ) {
    this.form = this.fb.group({
      deleteRelated: [false]
    });
  }

  onConfirm(): void {
    this.dialogRef.close({
      confirmed: true,
      deleteRelated: this.form.get('deleteRelated')?.value
    });
  }

  onCancel(): void {
    this.dialogRef.close({ confirmed: false });
  }
} 
